import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

type Locale = 'es' | 'fr';

const localeCopy: Record<Locale, { title: string; subtitle: string; cta: string; hero: string }> = {
  es: {
    title: 'ClipThis en Español',
    subtitle: 'Convierte videos largos en clips virales listos para TikTok, Reels y Shorts en minutos.',
    cta: 'Comienza gratis',
    hero: 'Herramientas de IA para creadores hispanohablantes',
  },
  fr: {
    title: 'ClipThis en Français',
    subtitle: "Transformez vos vidéos longues en clips prȇts pour TikTok, Reels et Shorts en quelques minutes.",
    cta: 'Essayez gratuitement',
    hero: 'Outils IA pour créateurs francophones',
  },
};

interface LocalizedLandingProps {
  locale: Locale;
}

const LocalizedLanding: React.FC<LocalizedLandingProps> = ({ locale }) => {
  const copy = localeCopy[locale];

  return (
    <div className="relative min-h-screen bg-white overflow-hidden">
      <div className="absolute inset-0 dot-pattern-animated opacity-30 pointer-events-none" />
      <SEOHead
        title={copy.title}
        description={copy.subtitle}
        url={`/${locale}`}
        locale={locale === 'es' ? 'es_ES' : 'fr_FR'}
      />
      <section className="relative z-10">
        <div className="max-w-4xl mx-auto px-6 py-20 text-center animate-fade-up">
          <p className="text-red-600 uppercase tracking-[0.3em] text-xs mb-3">{copy.hero}</p>
          <h1 className="text-5xl font-display font-bold text-gray-900 mb-4">{copy.title}</h1>
          <p className="text-xl text-gray-600 mb-8">{copy.subtitle}</p>
          <Link to="/signup" className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-black text-white text-lg font-semibold hover:bg-gray-900 transition-colors">
            {copy.cta}
          </Link>
        </div>
      </section>
    </div>
  );
};

export default LocalizedLanding;

